<script setup lang="ts">
import type { HTMLAttributes } from "vue";
import {
  PaginationEllipsis,
  type PaginationEllipsisProps,
} from "reka-ui";
import { cn } from "@/shared/lib/utils";

const props = defineProps<
  PaginationEllipsisProps & {
    class?: HTMLAttributes["class"];
  }
>();
</script>

<template>
  <PaginationEllipsis
    v-bind="props"
    :class="cn('flex h-9 w-9 items-center justify-center', props.class)"
  >
    <slot>&#8230;</slot>
  </PaginationEllipsis>
</template>
